/**
 * Companies with their own copy of some pages, served under `/fn` with the
 * same path (see `FnRedirectGate` in App.jsx). Company codes, upper case.
 */
export const FN_COMPANIES = ['TRENORD'];

/** Route prefix of the forked pages. */
export const FN_PREFIX = '/fn';

/** Homepage of FN users, in place of the dashboard (`/home`). */
export const FN_HOME = `${FN_PREFIX}/home/timeline`;

/** `user.company` is the company code. */
export function isFnCompany(code) {
  return FN_COMPANIES.includes(String(code || '').toUpperCase());
}
